import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MD } from '../global_vars';
import { animateText } from '../utils/miscellanea';

import * as basicLightbox from 'basiclightbox';
import 'basiclightbox/src/styles/main.scss';
import GFade from '../components/gfade/GFade';


@Component({
  components: {
    GFade
  }
})
export default class VMContacts extends Vue {
  mounted(): void {
    if (MD.mobile()) return;
    animateText(<HTMLElement>this.$refs.title).then();
  }

  openMap(k: string) {
    basicLightbox.create(
      document.getElementById(`map_${k}`)!.innerHTML
    ).show();
  }
}
